/******/ (() => {
  var isDefined = customElements.get('localization-form');

  if (!isDefined) {
    class LocalizationForm extends HTMLElement {
      connectedCallback() {
        this.elements = {
          input: this.querySelector('input[name="language_code"],input[name="country_code"]'),
          button: this.querySelector('.disclosure__button'),
          panel: this.querySelector('ul'),
        };

        if (!this.elements.button || !this.elements.input || !this.elements.panel) {
          console.warn('LocalizationForm: elementos no encontrados');
          return;
        }

        // 🔒 Asegurar que arranca cerrado
        this.elements.panel.setAttribute('aria-hidden', 'true');
        this.elements.button.setAttribute('aria-expanded', 'false');

        // 🕒 Solo una vez al render
        setTimeout(() => {
          this.elements.panel.setAttribute('aria-hidden', 'true');
          this.elements.button.setAttribute('aria-expanded', 'false');

          // 👁 Monitor cambios (debug only)
          const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.attributeName === 'aria-hidden') {
                console.info('↔️ Cambio aria-hidden:', this.elements.panel.getAttribute('aria-hidden'));
              }
            }
          });

          observer.observe(this.elements.panel, { attributes: true });
        }, 50);

        // 🎯 Eventos
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('blur', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.addEventListener('click', (event) => {
          let button = event.target.closest('.disclosure__item_el');
          if (!button) return;

          const form = button.closest('form');
          const input = form?.querySelector('input[name="country_code"], input[name="language_code"]');

          if (input && button.dataset.value) {
            input.value = button.dataset.value;
            form.submit();
          }
        });
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('aria-hidden', 'true');
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }

      openSelector() {
        const isOpen = this.elements.panel.getAttribute('aria-hidden') === 'false';
        this.elements.panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        this.elements.button.setAttribute('aria-expanded', (!isOpen).toString());
      }

      closeSelector(event) {
        const shouldClose = !event.relatedTarget?.classList?.contains('disclosure__item_el');
        if (shouldClose) {
          this.hidePanel();
        }
      }
    }

    customElements.define('localization-form', LocalizationForm);
  }
/******/ })();
